import { ITestProvider } from '../../Features/LoadingBar/loadingBarReducer';
import { IRunTriggerFn } from '../../Features/LoadingBar/LoadingBarActionTypes';
import { Environment } from '../Environment';

export const loadRecaptchaScript = () => {
  const scriptElement: HTMLScriptElement = document.createElement('script');
  scriptElement.setAttribute('type', 'text/javascript');
  scriptElement.setAttribute('async', '');
  scriptElement.setAttribute('defer', '');
  scriptElement.src = `https://www.google.com/recaptcha/api.js?render=${Environment.RECAPTCHA_SITE_KEY}`;

  return new Promise<ITestProvider<HTMLScriptElement>>((resolve) => {
    const timeoutId = setTimeout(
      () =>
        resolve({
          status: 'ERROR',
          reason: 'recaptcha api failed to load; timeout reached',
        }),
      3000,
    );

    scriptElement.addEventListener(
      'load',
      () => {
        resolve({ status: 'LOADED', instance: scriptElement });
        clearTimeout(timeoutId);
      },
      false,
    );
    scriptElement.onerror = (event) => {
      resolve({
        status: 'ERROR',
        reason:
          typeof event === 'string'
            ? `recaptcha api failed to load; ${event}`
            : 'recaptcha api failed to load; error encountered while loading script',
      });
      clearTimeout(timeoutId);
    };

    document.head.appendChild(scriptElement);
  });
};

export const waitForRecaptchaToBeReady = () =>
  new Promise<ITestProvider<IReCaptchaInstance>>((resolve) => {
    const timeoutId = setTimeout(
      () =>
        resolve({
          status: 'ERROR',
          reason: 'recaptcha provider did not load; timeout reached',
        }),
      3000,
    );

    window.grecaptcha.ready(() => {
      resolve({ status: 'LOADED', instance: window.grecaptcha });
      clearTimeout(timeoutId);
    });
  });

export const executeRecaptcha =
  (recaptcha: IReCaptchaInstance): IRunTriggerFn =>
  async (triggerType) => {
    try {
      return {
        status: 'LOADED',
        value: await recaptcha.execute(Environment.RECAPTCHA_SITE_KEY, {
          action: triggerType,
        }),
      };
    } catch (err) {
      return {
        status: 'ERROR',
        reason:
          err instanceof Error
            ? `recaptcha execute error; ${err.message}`
            : `recaptcha execute error; unknown failure`,
      };
    }
  };
